import { createSvgIcon } from '@mui/material';

export const UplanIcon = createSvgIcon(
    <svg viewBox="0 0 16 16" fill="currentColor">
      <defs>
        <style>
          {`.cls-1 { stroke-width: 0px; }`}
        </style>
      </defs>
      <path className="cls-1" d="M4.67,15.86H1.96c-1.03-.01-1.86-.78-1.86-1.72v-7.29c0-.49.23-.96.63-1.28L7.01.48c.56-.46,1.41-.46,1.98,0l6.29,5.1c.4.32.63.79.63,1.28v7.29c0,.94-.84,1.71-1.87,1.71h-3.34v-1.51h3.34c.22,0,.35-.13.35-.2v-7.29s-.03-.07-.07-.1L8.04,1.66s-.06,0-.08,0L1.67,6.75s-.07.07-.07.1v7.29c0,.07.13.2.35.2h2.17s4.54-3.71,4.54-3.71l.96,1.17-4.96,4.07Z"/>
    </svg>
    ,
    'UplanIcon'
);